// OPTIMIZED QUICK ADD PERFORMANCE FIX
(function () {
  'use strict';

  let quickAddProcessing = false;

  // Use capture phase to intercept clicks before other handlers
  document.addEventListener(
    'click',
    function (e) {
      const quickAddButton = e.target.closest('.quick-add__submit') || e.target.closest('.overlay-add-button');

      if (quickAddButton && !quickAddProcessing) {
        quickAddProcessing = true;

        // Immediately disable heavy operations
        if (window.ProductCardManager) {
          window.ProductCardManager.paused = true;
        }

        // Defer all non-critical operations
        requestAnimationFrame(() => {
          // Allow form submission to proceed immediately
          setTimeout(() => {
            if (window.ProductCardManager) {
              window.ProductCardManager.paused = false;
            }
            quickAddProcessing = false;
          }, 1000);
        });
      }
    },
    true
  ); // Capture phase - runs before other handlers
})();
